const ExpenseStatusConstants = {
    DRAFT: 0,
    SUBMITTED: 1,
    APPROVED: 2,
    DECLINED: 3,
    PAID: 4,
    NOT_REIMBURSABLE: 5
}

export default ExpenseStatusConstants